import React, { useState } from 'react';
import UsersTab from './admin/UsersTab';
import ImageGalleryTab from './admin/ImageGalleryTab';

type Tab = 'users' | 'images';

const TABS: { id: Tab; label: string }[] = [
    { id: 'users', label: 'Users' },
    { id: 'images', label: 'Image Gallery' },
];

/**
 * Administration, as two tabs.
 *
 * Both halves used to be stacked on one page, so managing access meant
 * scrolling past a table of pictures, and the page grew a second unrelated
 * loading state and error banner. They now share only the heading.
 *
 * Each tab mounts on selection and fetches then, rather than both loading up
 * front: the user list is what an administrator almost always came for, and it
 * should not wait on the image store to answer.
 */
const AdminPage: React.FC = () => {
    const [tab, setTab] = useState<Tab>('users');

    return (
        <div className="bx-wrap py-8 fade-in">
            <div className="mb-6">
                <h1 className="text-3xl font-bold text-slate-800">Admin</h1>
                <p className="text-slate-500 mt-1">Manage user permissions and shared content</p>
            </div>

            <div className="border-b border-slate-200 mb-8">
                <nav className="flex gap-6" aria-label="Admin sections">
                    {TABS.map(({ id, label }) => (
                        <button
                            key={id}
                            onClick={() => setTab(id)}
                            aria-current={tab === id ? 'page' : undefined}
                            className={`pb-3 -mb-px border-b-2 text-sm font-medium transition-colors ${
                                tab === id
                                    ? 'border-blue-600 text-blue-700'
                                    : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
                            }`}
                        >
                            {label}
                        </button>
                    ))}
                </nav>
            </div>

            {tab === 'users' ? <UsersTab /> : <ImageGalleryTab />}
        </div>
    );
};

export default AdminPage;
